import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=5672ad1e"
import script from "./Fab.vue?vue&type=script&lang=js"
export * from "./Fab.vue?vue&type=script&lang=js"
import style0 from "./Fab.vue?vue&type=style&index=0&id=5672ad1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports